import React from 'react';
import styled from 'styled-components';
import Section from '../Atoms/Section';
import BigH2 from '../Atoms/BigH2';
import artdevivre from '../../Components/img/artdevivre-1.png';
import audace from '../../Components/img/audace-1.png';
import coeur from '../../Components/img/coeur-1.png';
import creativiteetindustrie from '../../Components/img/creativiteetindustrie-1.png';
import eleganceettouche from '../../Components/img/eleganceettouche-1.png';
import equilibre from '../../Components/img/equilibre-1.png';
import heritage from '../../Components/img/heritage-1.png';
import innovation from '../../Components/img/innovation-1.png';
import ouverture from '../../Components/img/ouverture-1.png';
import panache from '../../Components/img/panache-1.png';
import savoirfaire from '../../Components/img/savoir-faire-1.png';
import { useTranslation } from 'react-i18next';
import AnimatedSection from '../Components/AnimatedSection';











import BigH3 from '../Atoms/BigH3';
import BlueButton from '../Atoms/BlueButton';
import BigH1 from '../Atoms/BigH1';
// import artdevivre from '../../../public/img/artdevivre1.png';


const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  padding: 20px;
`;
const Card = styled.div`
  width: 300px;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 400px; /* Define a fixed height for all cards */
  padding: 20px;
  box-sizing: border-box;
`;

const CardImage = styled.img`
  width: 100%;
  height: 150px; /* Set a fixed height for images */
  object-fit: contain; /* Ensure the image scales properly */
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const CardTitle = styled.h4`
  font-weight: bold;
  margin: 10px 0;
  min-height: 40px; /* Ensures all titles occupy the same vertical space */
  display: flex;
  align-items: center; /* Centers text vertically within the allocated space */
  justify-content: center;
  color:#0000ff;
`;

const CardText = styled.p`
  font-size: 14px;
  text-align: center;
  flex-grow: 1; /* Allows the text section to expand and ensure alignment */
`;


const StyledSection = styled(Section)`
  /* padding: 40px; */
`;




const StyledBigH2 = styled(BigH2)`
  text-align: left;
  /* margin-bottom: 30px; */
`;

const TeamCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const TeamCard = styled.div`
  background-color: blue;
  color: white;
  width: 250px;
  padding: 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.div`
    width: 100%;
    border-bottom: 1px solid black;
    padding: 30px 0;
    text-align: left;
    padding-left:40px;
`;

const TextSection = styled.div`
width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding:20px 0;
@media (max-width: 768px) {
  width:100%; 
   }
`;

const Dualsection = styled(Section)`
padding: 0 0 0 40px;
  display:flex;
  justify-content: space-between;
  border:none;


  @media (max-width: 768px) {
   flex-direction:column;
  }

`;

// const Video = styled.div`
//       @media (max-width: 768px) {
//         width: 100%;
//   }
    /* border-bottom: 1px solid black;
    padding: 30px 0;
    text-align: left;
    padding-left:40px; */
// `;

const Video = styled.iframe`
  width: 50%; /* Responsive width */
  height: 340px; /* Fixed height for consistency */
  border: none;
  margin: auto 0;
  @media (max-width: 768px) {
       width: 100%;
  } 
`;




// const CardTitle = styled.h4`
//   font-weight: bold;
//   margin: 10px 0;
// `;

const TeamCardText = styled.p`
  font-size: 14px;
`;


const Subsection = styled.div`
 padding:40px;
`;



const Apropos = () => {
  const { i18n } = useTranslation('common');

  return (
    <div>
      <StyledSection>
      <AnimatedSection direction="right" delay={100}>

      <Title>
        <StyledBigH2>CONNECTED BY Le FRENCH DESIGN</StyledBigH2>
        </Title>
        </AnimatedSection>
        <Dualsection>
          <TextSection>
        <p style={{marginBottom:'10px'}}>
          <strong>CONNECTED BY Le FRENCH DESIGN</strong> {i18n.language === "fr" ? "est la plateforme française qui connecte les acteurs du secteur de l’ameublement et des espaces de vies. Elle référence à la fois les fabricants français, les éditeurs, les designers, les scénographes et les architectes de notre communauté Le FRENCH DESIGN." : "is a French platform that brings together professionals in the furnishings and living spaces sector. It references the French manufacturers, editors, designers, scenographers and architects in our Le FRENCH DESIGN community."}
        </p>
        <p>
        {i18n.language === "fr" ? `En rejoignant cette communauté, vous bénéficiez d’un accès prioritaire et à des tarifs
          réduits à nos programmes et événements, ainsi qu'à des ressources documentaires
          spécialisées. Votre profil est publié dans notre annuaire exclusif, auquel vous avez
          également un accès privilégié pour élargir votre réseau. De plus, vos projets sont
          valorisés grâce à une communication dédiée sur nos réseaux, contribuant ainsi à
          promouvoir l'excellence du design français à l'international.` : `As a member of this community, you will benefit from priority access to our programmes and
          events, as well as specialist documentary resources, at reduced rates. Your profile is
          published in our exclusive directory, to which you also have special access to expand your
          network. In addition, your projects will be promoted through targeted communication on our
          networks, helping to promote the excellence of French design internationally.`}
        </p>
        </TextSection>
        <Video  src="https://www.youtube.com/embed/x4-Prpo4MwQ?si=P_q95O0OSVeuU9rC" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen/>
         </Dualsection>
      </StyledSection>
  
      <StyledSection>
      <AnimatedSection direction="left" delay={300}>

        <Title>
        <StyledBigH2> Le FRENCH DESIGN</StyledBigH2>
        </Title>
        </AnimatedSection>
        <AnimatedSection direction="up" delay={400}>

        <Subsection>

        <p style={{marginBottom:'10px'}}> 
          <strong>Le FRENCH DESIGN</strong>  {i18n.language === "fr" ? ` valorise l’Innovation dans l’Ameublement et l’architecture
          d’intérieur. Tête chercheuse depuis quarante ans, il décrypte les tendances du cadre de vie
          contemporain et initie études et projets prospectifs, favorisant les rencontres entre créateurs,
          designers, architectes, scientifiques, artisans, industriels et éditeurs, décloisonnant les
          disciplines pour imaginer les espaces de vie de demain.` : ` promotes innovation in furniture and interior design. For forty years,
Le FRENCH DESIGN has been at the forefront of research, deciphering trends in
contemporary living environments and initiating studies and forward-looking projects,
encouraging meetings between creators, designers, architects, scientists, craftspeople,
manufacturers and editors, breaking down the barriers between disciplines to imagine the
living spaces of tomorrow.`}
        </p>
        <p>
           {i18n.language === "fr" ? `10 valeurs fondamentales ont été identifiées comme étant l’âme et l’identité du design « à la
          française ». Ces valeurs, issues d’un comité de réflexion réunissant des figures influentes
          françaises et internationales, dépassent le cadre de l’exposition pour s’imposer comme une
          véritable philosophie :` : `10 fundamental values have been identified as the soul and identity of French style design.
These values, developed by a think-tank of influential French and international figures, go
beyond the framework of the exhibition and have become a real philosophy:`}
        </p>
        </Subsection>
        </AnimatedSection>
        <AnimatedSection direction="right" delay={500}>

        <CardContainer>
  <Card>
    <CardImage src={artdevivre} alt="Art de vivre" />
    <CardContent>
    <CardTitle>Art de vivre</CardTitle>
    <CardText>
      {i18n.language === "fr"
        ? "Humanisme et hédonisme, comment résumer ce « je-ne-sais-quoi » qui fait le charme et l'esprit de l'art de vivre à la française."
        : "Humanism and hedonism, a distillation of the “je ne sais quoi” which underpins the charm and spirit of French art de vivre."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={creativiteetindustrie} alt="Créativité & Industrie" />
    <CardContent>

    <CardTitle>Créativité & Industrie</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Le design forme un pont entre le monde artistique poétique et le monde rigoureux des industriels. Des alliances qui font la force du savoir-faire français."
        : "Design forms a bridge between the poetic, artistic world and the more rigorous manufacturing sector. And it is these connections which give French savoir-faire its strength."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={eleganceettouche} alt="Élégance et touche de luxe" />
    <CardContent>

    <CardTitle>Élégance et touche de luxe</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Le chic parisien, le raffinement français... Héritiers d'une histoire et viscéralement inscrits dans sa culture... Un style et un état d'esprit qui ont toujours fasciné le monde."
        : "Parisian chic, French refinement... Heirs to a rich history and deeply rooted in its culture... A style and a state of mind that have always captivated the world."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={innovation} alt="Innovation durable" />
    <CardContent>

    <CardTitle>Innovation durable</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Pas de limite dans la créativité et l'esthétique, mais une conception éco-responsable, un engagement maîtrisé, une maturité et une cohérence avec la société actuelle qui ne veut plus gâcher."
        : "Without limiting creativity and aesthetics, an environmentally friendly methodology is adopted, involving firm commitment, a mature approach, and adherence to contemporary society’s rejection of waste."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={audace} alt="Audace" />
    <CardContent>

    <CardTitle>Audace</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Casser les codes. S'autoriser une forme de liberté même pour des objets fonctionnels, oser la couleur et des matériaux insolites, provoquer un peu, séduire toujours !"
        : "Thinking outside the box. Permitting oneself certain freedoms, even for functional objects, daring to use original colours and materials, slightly provocative, entirely seductive!"}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={savoirfaire} alt="Savoir-faire" />
    <CardContent>

    <CardTitle>Savoir-faire</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Plus loin que la compétence et la technicité : c'est la qualité du savoir-faire, poussé dans le moindre détail, c'est l'école de l'excellence."
        : "Taking things further than competence and technical proficiency, high-quality know-how is applied to the smallest detail, in pursuit of true excellence."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={equilibre} alt="Équilibre" />
    <CardContent>

    <CardTitle>Équilibre</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "L'équilibre n'est pas forcément dans le dépouillement ou dans le travail des lignes, l'équilibre est une cohérence d'ensemble de l'objet et de son rapport au monde qui l'entoure."
        : "Balance is not necessarily about stripped-back design or carefully worked lines, it can be found in the overall consistency of an object and its relationship with the surrounding world."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={heritage} alt="Heritage" />
    <CardContent>

    <CardTitle>Héritage</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Des racines profondes et cultivées au cours des siècles, perpétuées avec respect en y apportant modernité et nouvelles technologies."
        : "Deep roots, cultivated over many centuries, respecting tradition while embracing modernity and new technology."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={ouverture} alt="Ouverture culturelle" />
    <CardContent>

    <CardTitle>Ouverture culturelle</CardTitle>

    <CardText>
      {i18n.language === "fr"
        ? "Une diversité d'écritures, l'intégration des talents internationaux, une ouverture d'esprit font la richesse et la singularité du le french design."
        : "Its stylistic breadth, incorporation of international talent and open spirit have all shaped the rich and exceptional character of le French Design."}
    </CardText>
    </CardContent>
  </Card>
  <Card>
    <CardImage src={panache} alt="Panache" />
    <CardTitle>Panache</CardTitle>
    <CardContent>


    <CardText>
      {i18n.language === "fr"
        ? "Le french flair, ou la fantaisie à bon escient et au bon moment. Avec ce petit goût de l'impertinence, pour bien marquer les esprits."
        : "French flair, or the judicious and timely use of the imagination, with just a touch of impertinence, to really make an impression."}
    </CardText>
    </CardContent>
  </Card>
</CardContainer>
</AnimatedSection>
      </StyledSection>
      <AnimatedSection direction="right" delay={600}>

      <StyledSection style={{textAlign:"center", padding:"40px" }}>
        <BigH2 style={{marginBottom:"20px", }}> {i18n.language === "fr"
        ? "Une question ?"
        : "A question?"}</BigH2>
        <BigH3 style={{marginBottom:"20px", }}>{i18n.language === "fr"
        ? "Nos chefs de projets sont à votre écoute !"
        : "      Our project managers are here to listen to you!"}</BigH3>
        <BlueButton mailto="arthur.boval@gmail.com" className='centered'> {i18n.language === "fr"
        ? "Nous contacter"
        : "Contact Us"}</BlueButton>

       
      </StyledSection>
      </AnimatedSection>

      
    </div>

  );
};

export default Apropos;
